import { styled } from '@teko/ds-desktop';
import React from 'react';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

const SmallImage = ({
  image,
  isActive,
  extra,
  onClick,
  onMouseEnter
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    isActive: !!isActive,
    onClick,
    onMouseEnter
  }, /* @__PURE__ */ React.createElement(EnhancedImage, {
    src: image.src,
    alt: image.alt,
    objectFit: "contain",
    borderRadius: 4,
    width: "50px",
    height: "50px"
  }), extra && /* @__PURE__ */ React.createElement(Extra, null, extra));
};
const Wrapper = styled.div(({ isActive, theme }) => `
  border-radius: 4px;
  border: 1px solid ${isActive ? theme == null ? void 0 : theme.colors.primary500 : "transparent"};
  position: relative;
  cursor: pointer;
  width: 50px;
  height: 50px;
  overflow: hidden;
`);
const Extra = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export { SmallImage };
